import { render, staticRenderFns } from "./MediaPropertyForm.vue?vue&type=template&id=ad53a0dc&"
import script from "./MediaPropertyForm.vue?vue&type=script&lang=ts&"
export * from "./MediaPropertyForm.vue?vue&type=script&lang=ts&"
import style0 from "./MediaPropertyForm.vue?vue&type=style&index=0&id=ad53a0dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports